var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'rtl-lang': _vm.isTextRightSided,
    'dev-env': _vm.isDev,
    'brand-ocean': _vm.brand === 'ocean',
  },attrs:{"id":"sw-app","dir":_vm.getDirection}},[_c('div',{staticClass:"icons-sprite"},[_c('BaseIconsSprite')],1),_c('div',{attrs:{"id":"nav"}}),_c('div',{attrs:{"id":"search-popup"},on:{"click":_vm.showPopup}},[_vm._t("default")],2),(_vm.mainPopupOpened)?_c('Popup',{class:{ 'is-popup-displayed': _vm.mainPopupOpened }}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }